import dateTimeFormatter from '../../../components/valueFormatter/dateTimeFormatter';
import useUserRoles from '../../../hooks/useUserRoles';
import steelMakerFilterValueGetter from '../../../components/filterValueGetter/steelMakerFilterValueGetter';
import updatedByFilterValueGetter from '../../../components/filterValueGetter/updatedByFilterValueGetter';
import createdByFilterValueGetter from '../../../components/filterValueGetter/createdByFilterValueGetter';
import dateFilterComparator from '../../../utils/ag-grid/dateFilterComparator';
import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefManageDeliveryLocation = (t: TFunction<'translation', undefined>) => {
  const { isMaintenanceadmin } = useUserRoles();
  const colDefs: ColDef[] = [
    {
      headerName: '',
      colId: 'actions',
      cellRenderer: 'actionsRenderer',
      editable: false,
      filter: false,
      pinned: 'left',
      suppressMenu: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      width: 90,
      hide: !isMaintenanceadmin,
    },
    {
      field: 'steelMaker',
      headerName: t('deliveryLocation.steelMaker'),
      headerTooltip: t('deliveryLocation.steelMaker'),
      cellRenderer: 'steelMakerCellRenderer',
      filterValueGetter: steelMakerFilterValueGetter,
    },
    {
      field: 'code',
      headerName: t('deliveryLocation.code'),
      headerTooltip: t('deliveryLocation.code'),
    },
    {
      field: 'deliveryName',
      headerName: t('deliveryLocation.deliveryLocationName'),
      headerTooltip: t('deliveryLocation.deliveryLocationName'),
    },
    {
      field: 'updatedAt',
      headerName: t('grid.updatedAt'),
      headerTooltip: t('grid.updatedAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateTimeFormatter,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      field: 'updatedBy',
      headerName: t('grid.updatedBy'),
      headerTooltip: t('grid.updatedBy'),
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: updatedByFilterValueGetter,
      minWidth: 100,
      maxWidth: 200,
    },
    {
      field: 'createdAt',
      headerName: t('grid.createdAt'),
      headerTooltip: t('grid.createdAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateTimeFormatter,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      field: 'createdBy',
      headerName: t('grid.createdBy'),
      headerTooltip: t('grid.createdBy'),
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: createdByFilterValueGetter,
      minWidth: 100,
      maxWidth: 200,
    },
  ];

  return colDefs;
};

export default useColdefManageDeliveryLocation;
